import { render, staticRenderFns } from "./webviewdomain.vue?vue&type=template&id=37a2ca4d&"
import script from "./webviewdomain.vue?vue&type=script&lang=ts&"
export * from "./webviewdomain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports